(() => {
  console.log('[Wholesale] Script loaded');
  const WHOLESALE_ENDPOINT = 'https://wsale.threeworlds.com.au/create-draft.php';

  function isWholesaleCustomer() {
    const result = window.theme?.customer?.isWholesale || false;
    console.log('[Wholesale] Customer check:', {
      hasTheme: !!window.theme,
      hasCustomer: !!window.theme?.customer,
      customerData: window.theme?.customer,
      isWholesale: result
    });
    return Boolean(result);
  }

  function createWholesaleButton(referenceButton) {
    const button = referenceButton.cloneNode(true);
    button.type = 'button';
    button.removeAttribute('name');
    button.removeAttribute('form');
    button.dataset.wholesaleSubmit = 'true';

    const textNode = button.querySelector('.btn-text');
    if (textNode) {
      textNode.textContent = 'Send wholesale order';
    }

    return button;
  }

  function createFeedbackNode() {
    const p = document.createElement('p');
    p.className = 'text-sm text-opacity wholesale-cart-feedback';
    p.style.width = '100%';
    p.style.gridColumn = '1 / -1'; // Span all columns in grid
    p.hidden = true;
    return p;
  }

  function createAddressSelector() {
    const wrapper = document.createElement('div');
    wrapper.className = 'wholesale-address-selector';
    wrapper.style.width = '100%';
    wrapper.style.gridColumn = '1 / -1'; // Span all columns in grid
    wrapper.style.marginBottom = '1rem';

    const label = document.createElement('label');
    label.className = 'text-sm font-medium';
    label.textContent = 'Shipping Address';
    label.style.display = 'block';
    label.style.marginBottom = '0.5rem';

    const select = document.createElement('select');
    select.className = 'wholesale-address-select';
    select.style.width = '100%';
    select.style.padding = '0.75rem';
    select.style.border = '1px solid #d1d5db';
    select.style.borderRadius = '0.375rem';
    select.style.fontSize = '0.875rem';
    select.dataset.wholesaleAddressSelect = 'true';

    // Add default option
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'Select a shipping address...';
    select.appendChild(defaultOption);

    // Check if we're editing a draft and should restore a specific address
    const savedAddressId = localStorage.getItem('wholesale_shipping_address_id');

    // Populate with customer addresses
    const customer = window.theme?.customer;
    if (customer && customer.addresses && customer.addresses.length > 0) {
      customer.addresses.forEach((address, index) => {
        const option = document.createElement('option');
        option.value = index;
        option.dataset.addressData = JSON.stringify(address);
        option.dataset.addressId = address.id;

        // Format address for display
        const addressParts = [];
        if (address.first_name || address.last_name) {
          addressParts.push(`${address.first_name || ''} ${address.last_name || ''}`.trim());
        }
        if (address.address1) addressParts.push(address.address1);
        if (address.city) addressParts.push(address.city);
        if (address.province_code) addressParts.push(address.province_code);
        if (address.zip) addressParts.push(address.zip);

        option.textContent = addressParts.join(', ');

        // Pre-select address: prioritize saved address from draft edit, otherwise default address
        if (savedAddressId && address.id && String(address.id) === String(savedAddressId)) {
          option.selected = true;
          console.log('[Wholesale] Restored shipping address from draft:', address.id);
        } else if (!savedAddressId && address.default) {
          option.selected = true;
        }

        select.appendChild(option);
      });
    } else {
      // No addresses available
      const noAddressOption = document.createElement('option');
      noAddressOption.value = '';
      noAddressOption.textContent = 'No saved addresses available';
      noAddressOption.disabled = true;
      select.appendChild(noAddressOption);
    }

    wrapper.appendChild(label);
    wrapper.appendChild(select);
    return wrapper;
  }

  function setFeedback(feedbackNode, message, state) {
    if (!feedbackNode) return;
    feedbackNode.textContent = message || '';
    feedbackNode.hidden = !message;
    if (state) {
      feedbackNode.dataset.state = state;
    } else {
      delete feedbackNode.dataset.state;
    }
  }

  function displaySuccessModal(orderName, wasReplacement, feedbackNode) {
    // Create modal overlay
    const overlay = document.createElement('div');
    overlay.className = 'wholesale-success-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      padding: 20px;
    `;

    // Create modal content
    const modal = document.createElement('div');
    modal.className = 'wholesale-success-modal';
    modal.style.cssText = `
      background: white;
      border-radius: 8px;
      max-width: 500px;
      width: 100%;
      padding: 40px;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
      text-align: center;
    `;

    const headerText = wasReplacement ? 'Order Updated!' : 'Order Created!';
    const messageText = wasReplacement
      ? (orderName
        ? `Your updated wholesale order <strong>${orderName}</strong> has been sent and the previous draft has been removed.`
        : 'Your updated wholesale order has been sent and the previous draft has been removed.')
      : (orderName
        ? `Your wholesale order <strong>${orderName}</strong> has been created successfully!`
        : 'Your wholesale order has been created successfully!');

    modal.innerHTML = `
      <div style="font-size: 64px; margin-bottom: 20px;">✅</div>
      <h2 style="font-size: 28px; font-weight: 700; color: #ff9900; margin-bottom: 16px;">
        ${headerText}
      </h2>
      <p style="font-size: 16px; color: #374151; line-height: 1.6; margin-bottom: 24px;">
        ${messageText}
      </p>
      <p style="font-size: 14px; color: #6b7280; margin-bottom: 24px;">
        A confirmation email has been sent with all the details.
      </p>
      <button class="wholesale-success-btn" style="
        background: #ff9900;
        color: white;
        border: none;
        padding: 14px 32px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 6px;
        cursor: pointer;
        transition: background 0.2s;
        width: 100%;
      ">
        View Your Orders
      </button>
    `;

    const successBtn = modal.querySelector('.wholesale-success-btn');

    // Hover effect
    successBtn.addEventListener('mouseenter', () => {
      successBtn.style.background = '#e68a00';
    });
    successBtn.addEventListener('mouseleave', () => {
      successBtn.style.background = '#ff9900';
    });

    // Redirect on button click
    successBtn.addEventListener('click', () => {
      window.location.href = 'https://www.threeworlds.com.au/pages/draft-order';
    });

    overlay.appendChild(modal);
    document.body.appendChild(overlay);
  }

  async function submitWholesaleOrder(button, feedbackNode) {
    setFeedback(feedbackNode, '', '');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      // Get selected address
      const addressSelect = document.querySelector('[data-wholesale-address-select="true"]');
      let selectedAddress = null;

      if (addressSelect && addressSelect.value !== '') {
        const selectedOption = addressSelect.options[addressSelect.selectedIndex];
        const addressData = selectedOption.dataset.addressData;
        if (addressData) {
          try {
            selectedAddress = JSON.parse(addressData);
          } catch (e) {
            console.error('[Wholesale] Failed to parse address data:', e);
          }
        }
      }

      // Validate that an address is selected
      if (!selectedAddress) {
        throw new Error('Please select a shipping address before submitting your wholesale order.');
      }

      const cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartResponse.ok) throw new Error(`cart_${cartResponse.status}`);
      const cartData = await cartResponse.json();

      // Check if this is a draft edit (original_draft_id in cart attributes or localStorage)
      const originalDraftId = cartData.attributes?.original_draft_id || localStorage.getItem('wholesale_original_draft_id');

      const payload = {
        cart: cartData,
        customer: window.theme?.customer || null,
        shipping_address: selectedAddress,
        submitted_at: new Date().toISOString(),
        original_draft_id: originalDraftId ? parseInt(originalDraftId) : null
      };

      const response = await fetch(WHOLESALE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const result = await response.json();

      // Check if the server returned an error
      if (!response.ok || result.error) {
        const errorMessage = result.message || result.error || 'We could not send your wholesale order. Please try again.';
        throw new Error(errorMessage);
      }

      // Clear the cart after successful submission
      await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });

      // Clear the draft ID and shipping address from localStorage
      localStorage.removeItem('wholesale_original_draft_id');
      localStorage.removeItem('wholesale_shipping_address_id');

      const orderName = result?.draft_order?.name || '';
      const wasReplacement = result?.original_draft_deleted?.success;

      // Show success modal instead of simple feedback
      displaySuccessModal(orderName, wasReplacement, feedbackNode);
    } catch (error) {
      console.error('Wholesale cart submission failed', error);
      let errorMessage = error.message || 'We could not send your wholesale order. Please try again.';

      if (errorMessage === 'Failed to fetch') {
        errorMessage = 'Connection error: We could not reach the wholesale server. Please check your internet connection or try again in a moment. If the issue persists, please contact support.';
      }

      setFeedback(feedbackNode, errorMessage, 'error');
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  function hideFreeShippingBar(root = document) {
    const shippingBars = root.querySelectorAll('.free-shipping-bar');
    shippingBars.forEach(bar => {
      bar.style.display = 'none';
      console.log('[Wholesale] ✓ Hidden free shipping bar');
    });
  }

  function replaceCheckoutButtons(root = document) {
    console.log('[Wholesale] Running replaceCheckoutButtons', {
      isWholesale: isWholesaleCustomer(),
      root: root.tagName || 'document'
    });

    if (!isWholesaleCustomer()) {
      console.log('[Wholesale] Not a wholesale customer, skipping');
      return;
    }

    // Hide free shipping bar for wholesale customers
    hideFreeShippingBar(root);

    if (root.querySelector('[data-wholesale-submit="true"]')) {
      console.log('[Wholesale] Button already replaced');
      return;
    }

    const checkoutButton = root.querySelector('button[name="checkout"]');
    console.log('[Wholesale] Found checkout button:', checkoutButton);
    if (!checkoutButton) return;

    // Find container - try drawer first, then cart page
    const container = checkoutButton.closest('.drawer__footer-buttons') || checkoutButton.closest('.grid');
    console.log('[Wholesale] Found container:', container);
    if (!container) return;

    const wholesaleButton = createWholesaleButton(checkoutButton);
    const addressSelector = createAddressSelector();
    const feedbackNode = createFeedbackNode();

    wholesaleButton.addEventListener('click', () => submitWholesaleOrder(wholesaleButton, feedbackNode));

    checkoutButton.replaceWith(wholesaleButton);
    console.log('[Wholesale] ✓ Replaced checkout button with wholesale button');

    const acceleratedWrapper = container.querySelector('.additional-checkout-buttons');
    if (acceleratedWrapper) acceleratedWrapper.remove();

    // Insert address selector before the wholesale button
    wholesaleButton.parentNode.insertBefore(addressSelector, wholesaleButton);
    container.appendChild(feedbackNode);
  }

  function initWholesaleCart(root = document) {
    // Run on cart page
    if (document.body.classList.contains('template-cart')) {
      replaceCheckoutButtons(root);
    }
  }

  function initWholesaleDrawer() {
    console.log('[Wholesale] initWholesaleDrawer called');
    // Run in cart drawer
    const drawer = document.querySelector('cart-drawer');
    console.log('[Wholesale] Drawer element:', drawer);

    if (drawer) {
      // Wait a bit for drawer content to render
      setTimeout(() => {
        console.log('[Wholesale] Attempting to replace button in drawer');
        replaceCheckoutButtons(drawer);
      }, 300);
    }
  }

  // Subscribe to theme events early
  function subscribeToThemeEvents() {
    if (window.theme && window.theme.pubsub) {
      console.log('[Wholesale] Subscribing to theme cart updates');
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
        console.log('[Wholesale] Theme cartUpdate event received');
        setTimeout(() => {
          initWholesaleCart();
          initWholesaleDrawer();
        }, 100);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    console.log('[Wholesale] DOMContentLoaded - initializing');
    subscribeToThemeEvents();
    initWholesaleCart();
    initWholesaleDrawer();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initWholesaleCart(event.target);
    initWholesaleDrawer();
  });

  // Re-init drawer buttons when drawer opens or content changes
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      console.log('[Wholesale] No drawer element found');
      return;
    }

    console.log('[Wholesale] Setting up drawer observers');

    // Watch for when drawer opens
    const openObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'open' && drawer.hasAttribute('open')) {
          console.log('[Wholesale] Drawer opened - replacing button');
          setTimeout(initWholesaleDrawer, 500); // Increased delay
        }
      });
    });
    openObserver.observe(drawer, { attributes: true });

    // Watch for content changes inside drawer (like when items are added/removed)
    const contentObserver = new MutationObserver(() => {
      if (drawer.hasAttribute('open')) {
        console.log('[Wholesale] Drawer content changed');
        initWholesaleDrawer();
      }
    });
    contentObserver.observe(drawer, { childList: true, subtree: true });
  });

  // Also listen for Shopify cart updates
  document.addEventListener('cart:updated', () => {
    console.log('[Wholesale] Cart updated event');
    setTimeout(() => {
      initWholesaleCart();
      initWholesaleDrawer();
    }, 200);
  });

})();
